import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.Neutral5};
  gap: ${Spacing.XS};
  padding: ${Spacing.S};
  border-radius: ${Spacing.XS};
`

export const TextContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${Spacing['3XS']};
  text-align: center;

  img {
    display: none;
  }

  b,
  span {
    ${FontWeights.DemiBold};
  }
`
